/**
 * CA Backend OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { SubjectSignDateDto } from './subjectSignDateDto.model';
import { ContractGroupDto } from './contractGroupDto.model';
import { ContractRentDrupoz } from './contractRentDrupoz.model';
import { ContractParcelDataDo } from './contractParcelDataDo.model';
import { ContractOwnerParamRequestDto } from './contractOwnerParamRequestDto.model';
import { ValorizationType } from './valorizationType.model';
import { ContractPaymentDataCreateDto } from './contractPaymentDataCreateDto.model';
import { ContractSubjectRepresentativeRequestDto } from './contractSubjectRepresentativeRequestDto.model';
import { VersionType } from './versionType.model';
import { ContractRentUnknown } from './contractRentUnknown.model';


export interface ContractCreateRequestDto { 
    appendixNumber?: number;
    appendixSourceId?: number;
    autoProlongationMonths?: number;
    autoProlongationMonthsUnit?: string;
    autoProlongationRepeatedly: boolean;
    contractDocumentTemplate?: number;
    contractGroups?: Array<ContractGroupDto>;
    contractNumber?: number;
    contractNumberCustom?: string;
    contractNumberFormat: string;
    contractParamTemplate?: number;
    contractRentDrupozCollection?: Array<ContractRentDrupoz>;
    contractRentUnknownCollection?: Array<ContractRentUnknown>;
    contractYear?: number;
    counterpartyNumber?: string;
    cpds?: Array<ContractParcelDataDo>;
    createIndividualDocuments?: boolean;
    documentNote?: string;
    durationMonths?: number;
    durationMonthsUnit?: string;
    durationToDate?: string;
    endDate?: string;
    endType?: string;
    expirationDate?: string;
    firstNoticeAfterMonths?: number;
    firstNoticeAfterMonthsUnit?: string;
    furtherRentPossible: boolean;
    groupId?: number;
    id?: number;
    indefinite?: boolean;
    inflationLimit?: number | null;
    isWatched?: boolean;
    lastNoticeBeforeMonths?: number;
    lastNoticeBeforeMonthsUnit?: string;
    note?: string;
    noticeDate?: string;
    noticePeriodMonths?: number;
    noticePeriodMonthsUnit?: string;
    ownerIds: Array<number>;
    ownerRepresentatives?: Array<ContractSubjectRepresentativeRequestDto>;
    ownerparams: Array<ContractOwnerParamRequestDto>;
    parcelIds?: Array<number>;
    parcelPriceAdds?: Array<number>;
    payTaxOwner?: boolean;
    paymentDatas?: Array<ContractPaymentDataCreateDto>;
    paymentsFromEconomicYear?: boolean;
    payoutToId?: number;
    priceContract?: number;
    priceDeal?: number;
    priceDealPercentageValorization?: number | null;
    priceDealValorization?: number | null;
    rentType?: string;
    reqNewAppendixAfterReprice: boolean;
    resignDate?: string;
    reusedPreviousExpiration: boolean;
    sentForSignature?: boolean;
    signDates?: Array<SubjectSignDateDto>;
    signatureDate?: string;
    state?: string;
    subcontract?: boolean;
    successiveNumber?: number;
    successiveSourceId?: number;
    taxConcerned?: boolean;
    taxOwner?: number;
    taxOwnerToId?: number;
    taxTenant?: number;
    tenantHasPreemption?: boolean;
    tenantIds: Array<number>;
    tenantRepresentatives?: Array<ContractSubjectRepresentativeRequestDto>;
    toEconomicYear: boolean;
    useRentDrupoz?: boolean;
    valorizationType: ValorizationType;
    valorizeOrInflateToDate?: string | null;
    versionType?: VersionType;
    watchReason?: string;
}
export namespace ContractCreateRequestDto {
}


